import React, { useCallback, useEffect, useRef } from "react"
import styles from "./SimilarQuestionsList.module.scss"
import SampleQuestion from "../../../../../components/SampleQuestions/SampleQuestion/SampleQuestion"
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks"
import { MarkedMessageHash, MarkedMessageWithSelected } from "../../../../../models/article"
import {
    addOneUnmarkedMessageSelection,
    removeOneUnmarkedMessageSelection
} from "../../../../../store/knowledgeBase/slice"
import { similarQuestionsSelection } from "../../../../../store/knowledgeBase/selectors"
import { updateUnmarkedMessages } from "../../../../../store/knowledgeBase/thunks"
import { SIMILAR_QUESTIONS_PAGE_SIZE } from "../SimilarQuestionsContainer"

export interface SimilarQuestionsListProps {
    messages: MarkedMessageHash
    text: string
}

const SimilarQuestionsList = (props: SimilarQuestionsListProps) => {
    const { text, messages } = props
    const dispatch = useAppDispatch()
    const selectedQuestions = useAppSelector(similarQuestionsSelection)
    const messagesArray = Object.values(messages).map(message => {
        return { ...message, isSelected: Boolean(selectedQuestions[message.id]) }
    })
    const scrollRef = useRef<HTMLDivElement | null>(null)
    const messageText = messagesArray[messagesArray.length - 1]?.text

    const handleScroll = useCallback(() => {
        const element = scrollRef.current
        if (element && element.scrollHeight - element.scrollTop === element.clientHeight) {
            dispatch(updateUnmarkedMessages(text, SIMILAR_QUESTIONS_PAGE_SIZE, messageText))
        }
    }, [messageText, text])

    const handleSimilarQuestionSelect = (selected: boolean | undefined, message: MarkedMessageWithSelected) => {
        if (selected) {
            dispatch(removeOneUnmarkedMessageSelection(message.id))
        } else {
            dispatch(addOneUnmarkedMessageSelection(message))
        }
    }

    useEffect(() => {
        const element = scrollRef.current
        if (!element) {
            return
        }
        element.addEventListener("scroll", handleScroll)
        return () => {
            element.removeEventListener("scroll", handleScroll)
        }
    }, [handleScroll])

    return (
        <div className={styles.similarQuestionsList} ref={scrollRef}>
            {messagesArray.map(message => (
                <SampleQuestion
                    id={message.id}
                    content={message.text}
                    className={styles.similarQuestionsList_item}
                    displayCheckBox
                    key={message.id}
                    selected={message.isSelected}
                    testId={message.id}
                    onSelect={selected => {
                        handleSimilarQuestionSelect(selected, message)
                    }}
                ></SampleQuestion>
            ))}
        </div>
    )
}

export default SimilarQuestionsList
